import React, { Component } from 'react';
import SelectQuery from '../../../../component/SelectQuery.js';
import lang from 'config/language' 
import PopoverHelper from 'utils/PopoverHelper';

class form extends Component {
	render(){
		return(
			<div>
				<div className="card-block">
	        <div className="row">
	          <div className="col-md-12">
	            <div className="list-separator m-top-15" style={{ border : 'none'}}>
	              <div className="item-inner">
	                DEFAULT VALUE
	                <PopoverHelper
	                  id="default_mapping"
	                  content={lang.tenant_setting.default_value}
	                />
	              </div>
	            </div>
	          </div>
	          <div className="col-md-6">
	            <div className="form-group">
	              <label>Tenant Name</label>
	              <input type="text" className="form-control" value='' readOnly/>
	            </div>
	          </div>

	          <div className="col-md-4">
	            <div className="form-group">
	              <label>Default Currency</label>
	                <SelectQuery
	                  name="Site"
	                  placeholder="Storage Type"
	                  value='this.state.DefaultCurrency'
	                  urlKey="read-currency-autocomplete"
	                  valKey="pk"
	                  valLabel="Name"
	                  extra={'all=true'}
	                  initOption={{Name: "(IDR) Indonesian Rupiah",
											label: "(IDR) Indonesian Rupiah",
											pk: 1,
											value: 1}}
	                  //onChange={(val) => this.handleDefaultCurrencyChange(val)}
	                  UserReducer={this.props.UserReducer}
	                />
	            </div>
	          </div>
	          <div className="col-md-2">
	            <div className="form-group">
	              <div><label>Single Currency</label></div>
	              <label className="switch switch-lg switch-text switch-primary mb0">
	                <input
	                  //onChange={(event)=>this.handleSingleCurrencyChange(event)}
	                  name='singleCurency'
	                  type="checkbox"
	                  className="switch-input"
	                  // ******** WHY NEED CHECKED USE !!. because this.state.toggled not always boolean.
	                  // ******** and it make uncontroled component, for first time value for toggled is undifined
	                  checked={true}
	                />
	                <span className="switch-label" data-on="On" data-off="Off"></span>
	                <span className="switch-handle"></span>
	              </label>
	            </div>
	          </div>
	          <div className="col-md-6">
	            <div className="form-group">
	              Max Day
	              <PopoverHelper
	                id="max_day"
	                content={lang.tenant_setting.max_day}
	              />
	              <input
	                type="number"
	                name="GlobalMaxDay"
	                className="form-control"
	                placeholder="Max day"
	                value = {0}
	                //onChange={(val)=> this.setState({GlobalMaxDay: val.target.value})}
	              />
	            </div>
	          </div>
	          <div className="col-md-4">
	            <div className="form-group">
	              Urgency Day
	              <PopoverHelper
	                id="urgency_day"
	                content={lang.tenant_setting.urgency_day}
	              />
	              <input
	                type="number"
	                name="UrgencyDay"
	                className="form-control"
	                placeholder="Urgency day"
	                value = {0}
	                //onChange={(val)=> this.setState({UrgencyDay: val.target.value})}
	              />
	            </div>
	          </div>
	          <div className="col-md-2">
	            <div className="form-group">
	              <div>
	              Coverage City
	              <PopoverHelper
	                id="coverage_city"
	                placement="bottom"
	                content={lang.tenant_setting.coverage_city}
	              /></div>
	              <label className="switch switch-lg switch-text switch-primary mb0">
	                <input
	                  //onChange={(event)=>this.handleCoverageCityChange(event)}
	                  name='singleCurency'
	                  type="checkbox"
	                  className="switch-input"
	                  // ******** WHY NEED CHECKED USE !!. because this.state.CoverageCity not always boolean.
	                  // ******** and it make uncontroled component, for first time value for CoverageCity is undifined
	                  checked={true} 
	                />
	                <span className="switch-label" data-on="On" data-off="Off"></span>
	                <span className="switch-handle"></span>
	              </label>
	            </div>
	          </div>
	        </div>
	      </div>
				<button type="submit" className="btn btn-primary">Submit</button>
			</div>
		)
	}
}

export default form



// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/form/form.js